// Magnitude, one series — so a SEQUENTIAL ramp (one hue, light to dark), not
// categorical hues. Varying lightness rather than hue keeps the bars separable
// in greyscale and in print, which matters because owners forward these panels.
//
// Two ramps rather than one flipped ramp: a single span wide enough to read on
// white leaves its dark end at ~2:1 on the dark surface, and vice versa. Each was
// checked against its own surface with the dataviz validator — the dark ramp
// passes 3:1 outright; the light ramp's palest step (the brand blue, 2.31:1) is
// relieved by the always-visible category labels on the axis.
export const BAR_RAMP_LIGHT = ["#0B4F80", "#0F6396", "#14789F", "#1A8DC6", "#2099DF", "#32B1FF"];
export const BAR_RAMP_DARK = ["#9BDBFF", "#7ACDFF", "#5BC0FF", "#3DB4FF", "#32B1FF", "#2099DF"];

// Rows arrive sorted by value, so index 0 is the largest — the strongest step.
// Beyond the ramp the last step repeats rather than cycling back to the top,
// which would restart the scale and imply a second peak.
export const barFill = (ramp, i) => ramp[Math.min(i, ramp.length - 1)];
